module.exports = __webpack_public_path__ + "img/estatus-de-pagos-de-facturas-sometidas.0a2517a2.svg";